import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';

export function SidebarLinks(props: { routes: RoutesType[] }) {
    let location = useLocation();

    const { routes } = props;

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName: string) => {
        return location.pathname.includes(routeName);
    };

    // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
    const createLinks = (routes: RoutesType[]) => {
        return routes.map((route: RoutesType, index: number) => {
            if (route.layout === '/admin' || route.layout === '/auth') {
                return (
                    <NavLink key={index} to={route.layout + route.path}>
                        <Box>
                            <HStack
                                borderRadius="8px"
                                spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
                                py="5px"
                                ps="10px"
                                backgroundColor={activeRoute(route.path.toLowerCase()) ? 'gray.50' : 'transparent'}
                            >
                                <Flex w="100%" alignItems="center" justifyContent="center" height="38px">
                                    <Flex
                                        color={activeRoute(route.path.toLowerCase()) ? 'brand.500' : 'gray.500'}
                                        mr="12px"
                                    >
                                        {route.icon}
                                    </Flex>
                                    <Text
                                        fontSize="md"
                                        me="auto"
                                        color={activeRoute(route.path.toLowerCase()) ? 'gray.900' : 'gray.500'}
                                        fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}
                                    >
                                        {route.name}
                                    </Text>
                                </Flex>
                            </HStack>
                        </Box>
                    </NavLink>
                );
            }
        });
    };
    //  BRAND
    return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
